import { ref, markRaw, type Component } from "vue";

interface DialogConfig {
  width?: number | string;
  title?: string;
  subtitle?: string;
}

const defaultDialogWidth = 480;

export const currentDialogs = ref<
  Record<
    string,
    {
      component: Component;
      props?: Record<string, unknown>;
      config: DialogConfig & { closing?: boolean };
    }
  >
>({});

export const useDialog = () => {
  function showDialog(
    component: Component,
    props?: Record<string, unknown>,
    config: DialogConfig = {},
  ) {
    const key = `dialog-${Math.floor(Math.random() * 100000)}`;

    currentDialogs.value[key] = {
      component: markRaw(component),
      props,
      config: { width: defaultDialogWidth, ...config, closing: false },
    };

    return key;
  }

  function closeDialog(key: string) {
    if (!currentDialogs.value[key]) return;

    currentDialogs.value[key].config.closing = true;

    setTimeout(() => {
      delete currentDialogs.value[key];
    }, 300);
  }

  return { currentDialogs, showDialog, closeDialog };
};
